export default (() => {
	return {
		env: "prod",
		urls: {},
	};
})();
